import React, { useState } from 'react';
import { Form, Button, Spinner, Alert } from 'react-bootstrap';
import { FaEnvelope, FaUser } from 'react-icons/fa';
import { subscriberService } from '../services/api';
import toast from 'react-hot-toast';
import './NewsletterSignup.css';

const NewsletterSignup = ({ inline = false }) => {
  const [formData, setFormData] = useState({
    email: '',
    name: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);

    try {
      const response = await subscriberService.subscribe(formData);
      toast.success(response.data.message);
      setSuccess(true);
      setFormData({ email: '', name: '' });
    } catch (error) {
      const message = error.response?.data?.message || 'Failed to subscribe. Please try again.';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  if (inline) {
    // Inline version for footer
    return (
      <div className="newsletter-inline">
        <h5 className="newsletter-title">
          <FaEnvelope className="me-2" />
          Stay Updated
        </h5>
        <p className="newsletter-subtitle">Get the latest diving articles delivered to your inbox</p>
        
        {success ? (
          <Alert variant="success" className="success-message">
            ✓ Successfully subscribed! Check your email.
          </Alert>
        ) : (
          <Form onSubmit={handleSubmit} className="newsletter-form-inline">
            <Form.Group className="mb-2">
              <Form.Control
                type="text"
                id="newsletter-name-inline"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
                disabled={loading}
                autoComplete="name"
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Control
                type="email"
                id="newsletter-email-inline"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                required
                disabled={loading}
                autoComplete="email"
              />
            </Form.Group>
            <Button 
              type="submit" 
              className="subscribe-btn"
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Subscribing...
                </>
              ) : (
                'Subscribe'
              )}
            </Button>
          </Form>
        )}
      </div>
    );
  }

  // Card version for sidebar
  return (
    <div className="newsletter-card">
      <div className="newsletter-icon">
        <FaEnvelope />
      </div>
      <h4 className="newsletter-title">Newsletter</h4>
      <p className="newsletter-subtitle">
        Get the latest diving articles and trip updates delivered to your inbox
      </p>
      
      {success ? (
        <Alert variant="success" className="success-message">
          <strong>Welcome aboard!</strong><br />
          Check your email for a confirmation message.
        </Alert>
      ) : (
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <div className="input-group">
              <span className="input-icon">
                <FaUser />
              </span>
              <Form.Control
                type="text"
                id="newsletter-name"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
                disabled={loading}
                autoComplete="name"
              />
            </div>
          </Form.Group>
          
          <Form.Group className="mb-3">
            <div className="input-group">
              <span className="input-icon">
                <FaEnvelope />
              </span>
              <Form.Control
                type="email"
                id="newsletter-email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                required
                disabled={loading}
                autoComplete="email"
              />
            </div>
          </Form.Group>
          
          <Button 
            type="submit" 
            className="subscribe-btn w-100"
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Subscribing...
              </>
            ) : (
              'Subscribe to Newsletter'
            )}
          </Button>
        </Form>
      )}
      
      <p className="privacy-note">
        We respect your privacy. Unsubscribe anytime.
      </p>
    </div>
  );
};

export default NewsletterSignup;
